import { MimeContentType } from '../enums/mime-content-type.enum';

export const VIEWABLE_DOCUMENT_TYPES = [MimeContentType.Docx, MimeContentType.Pdf, MimeContentType.Rtf];
